import { createGame } from './game/Game';

// Entry point. Vite serves index.html which loads this module.
//
// Two modes, one flag:
//   (bare)    — the RUNTIME: boots the Phaser Game into #game, exactly the
//               shipping playable. `vite build` emits a self-contained bundle
//               any static host can serve.
//   ?edit=1   — ARCADE AUTHORING (arcade_authoring_spec): the React shell
//               wraps the same runtime stage. Dynamically imported so the
//               editor (React and all) never enters the runtime path — the
//               playable stays untouched by the authoring layer.
const search = (globalThis as { location?: { search?: string } }).location?.search ?? '';
if (new URLSearchParams(search).get('edit') === '1') {
  void import('./edit/mount').then((m) => m.mountAuthoring());
} else {
  const game = createGame();
  // Expose for in-browser debugging / verification harnesses. Harmless in
  // prod; nothing depends on it.
  (globalThis as unknown as { __arcade?: unknown }).__arcade = game;
}
